var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.roleLabel,
      "delete-dialog-title": _vm.$t("DeleteUser"),
      "delete-dialog-content":
        _vm.$t("DeleteConfirmation") +
        " " +
        _vm.$tc("Role", 1) +
        " " +
        _vm.roleLabel +
        "?",
      "permission-name": "user",
      "edit-button": _vm.isAdmin || _vm.isSuperAdmin,
      "delete-button": _vm.canRemoveItems,
      loading: _vm.loading
    },
    on: { editItem: _vm.editRole, deleteItem: _vm.deleteRole },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _c("view-page-data-field", {
              key: field.label,
              attrs: {
                icon: field.icon,
                label: field.label,
                data: field.data,
                hasPermission: field.hasPermission
              }
            })
          })
        },
        proxy: true
      },
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _c("management-tabs-and-search", {
              attrs: {
                tabs: _vm.tabs,
                "open-tab": _vm.openTab,
                search: _vm.search
              },
              on: {
                "update-open-tab": function($event) {
                  _vm.openTab = $event
                },
                "update-search": function($event) {
                  _vm.search[$event.tab] = $event.value
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _vm.role
              ? _c(
                  "v-tabs-items",
                  { attrs: { value: _vm.openTab } },
                  [
                    _c(
                      "v-tab-item",
                      { attrs: { value: "permissions" } },
                      [
                        _c("permissions-section", {
                          attrs: {
                            "account-type": "clientRole",
                            previousRolesAndPermissions:
                              _vm.previousRolesAndPermissions,
                            type: "view"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "webUsers" } },
                      [
                        _c("associated-users", {
                          attrs: {
                            "action-type": "view",
                            "user-type": "web",
                            from: "role",
                            "associated-users": _vm.role.usersWebAssociates,
                            "search-from-parent": _vm.search.webUsers
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "mobileUsers" } },
                      [
                        _c("associated-users", {
                          attrs: {
                            "action-type": "view",
                            "user-type": "mobile",
                            from: "role",
                            "associated-users": _vm.role.usersMobileAssociates,
                            "search-from-parent": _vm.search.mobileUsers
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { attrs: { value: "companies" } },
                      [
                        _c("associated-companies", {
                          attrs: {
                            from: "role",
                            "action-type": "view",
                            "associated-companies": _vm.role.companies,
                            "search-from-parent": _vm.search.companies
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42aee802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42aee802","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/ClientRoles/ClientRoleView.vue
// module id = null
// module chunks = 